function fosNorm(value) {
  return String(value ?? '')
    .toLocaleLowerCase()
    .replaceAll("'", '')
    .replaceAll('\u2019', '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

function requiredText(card, field, index) {
  const value = String(card?.[field] ?? '').replace(/\s+/g, ' ').trim()
  if (!value) throw new Error(`Pairing card ${index} is missing ${field}`)
  return value
}

export function validatePairingPayload(cards) {
  if (!Array.isArray(cards) || cards.length === 0) {
    throw new Error('Pairing resolver returned no cards')
  }

  const seenCatalogIds = new Set()
  const seenReasoning = new Set()
  const seenApplication = new Set()

  return cards.map((card, offset) => {
    const index = offset + 1
    const name = requiredText(card, 'name', index)
    const house = requiredText(card, 'house', index)
    const familyCompatibility = requiredText(card, 'family_compatibility', index)
    const layeringRoleSynergy = requiredText(card, 'layering_role_synergy', index)
    const whyItWorks = requiredText(card, 'why_it_works', index)
    const reasoning = requiredText(card, 'reasoning', index)
    const application = requiredText(card, 'application', index)
    const reasoningKey = fosNorm(reasoning)
    const applicationKey = fosNorm(application)
    const catalogId = String(card?.catalog_id || '').trim()
    const resolutionStatus = card?.resolution_status

    if (resolutionStatus === 'resolved') {
      if (!catalogId) throw new Error(`Resolved pairing card ${index} is missing catalog_id`)
      if (seenCatalogIds.has(catalogId)) {
        throw new Error(`Pairing resolver repeated catalog_id on card ${index}`)
      }
      seenCatalogIds.add(catalogId)
    } else if (resolutionStatus === 'unresolved') {
      if (catalogId) throw new Error(`Unresolved pairing card ${index} carries catalog_id`)
    } else {
      throw new Error(`Pairing card ${index} has invalid resolution_status`)
    }

    if (seenReasoning.has(reasoningKey)) {
      throw new Error(`Pairing set repeats reasoning on card ${index}`)
    }
    if (seenApplication.has(applicationKey)) {
      throw new Error(`Pairing set repeats application on card ${index}`)
    }
    seenReasoning.add(reasoningKey)
    seenApplication.add(applicationKey)

    return {
      ...card,
      name,
      house,
      family_compatibility: familyCompatibility,
      layering_role_synergy: layeringRoleSynergy,
      why_it_works: whyItWorks,
      reasoning,
      application,
    }
  })
}

export async function resolvePairingPayload(client, cards) {
  const { data, error } = await client.rpc('resolve_pairing_recommendations_v1', {
    p_cards: cards,
  })
  if (error) throw error
  return validatePairingPayload(data)
}
